// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext")
jQuery = require("jquery")

document.addEventListener("turbolinks:load", function() {
  jQuery('a.search__clear-text__icon').on('click', function(){
    jQuery(this).closest('form')[0].reset();
  })
  jQuery('button.intercom-reaction').on('click', function(){
    var data = jQuery(this).data();
    jQuery(this).closest('.intercom-reaction-picker').addClass('intercom-reaction-picker-reaction-selected');
    jQuery('button.intercom-reaction').removeClass('intercom-reaction-selected');
    jQuery(this).addClass('intercom-reaction-selected');
    jQuery.post(data.url, {reaction: data.reactionText, authenticity_token: jQuery('meta[name="csrf-token"]').attr('content')});
  })
  jQuery('.trix-content a').each(function(e){
    var $elThis = jQuery(this);
    var ahref = $elThis.attr('href');
    if(!!ahref && ahref != ' ' && ahref != '#' && ahref.indexOf(location.origin) < 0) {
      $elThis.attr('target', '_blank');
    }
  })
})
